import { render } from "./AdminManageBanner.vue?vue&type=template&id=24b6e1c5"
import script from "./AdminManageBanner.vue?vue&type=script&lang=js"
export * from "./AdminManageBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__